import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icon-excel.svg'


const _hoisted_1 = { class: "flex flex-col h-screen gap-4 w-full pt-[90px] px-4 lg:px-8" }
const _hoisted_2 = { class: "text-black bg-white focus:ring-4 gap-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm inline-flex items-center mr-2 mb-2 lg:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Icon description", -1)
const _hoisted_4 = { class: "flex sm:flex-row sm:h-12 flex-col justify-between lg:items-center items-start gap-4" }
const _hoisted_5 = { class: "flex flex-row justify-between sm:justify-normal items-center w-full gap-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px]" }, "Actualizar", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-row gap-4 items-center justify-between w-full sm:w-fit" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-[16px]" }, "Excel", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px]" }, "Filtrar", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center my-7" }, [
  /*#__PURE__*/_createTextVNode(" Esta acción borrara definitivamente este dividendo. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ¿ Desea continuar con la acción ? ")
], -1)

import { onMounted, ref, watch, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { DividendService } from "@/services/dividends/dividendService";
import { ShareholderService } from "@/services/shareholder/ShareholderService";
import {
  PaymentStatus,
  DividendType,
  formOptionsType,
  DividendsFilter,
  DividendStatusType,
  MultiplePaymentsData,
} from "@/services/dividends/types";

import { reformatDate, toBadgeFormat } from "@/services/utils";
import Swal from "sweetalert2";

import Modal from "@/components/atoms/Modal.vue";
import AppSpinner from "@/components/atoms/AppSpinner.vue";
import Selector from "@/components/atoms/Selector.vue";
import NewTableComponent from "@/components/molecules/NewTableComponent.vue";
import DividendDetailModal from "@/components/organisms/dividends/DividendDetailModal.vue";
import GenericDividensForm from "@/components/organisms/dividends/GenericDividendsForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DividendsViewWithId',
  setup(__props) {

const dividendNewStatus = ref<DividendStatusType>(DividendStatusType.PENDING);
const dividendService = new DividendService();
const shareholderService = new ShareholderService();

const selectedDividendToDelete = ref<number>();
const showNewDividendModal = ref<boolean>(false);
const isVisibleConfirmationModal = ref<boolean>(false);
const showDetailModal = ref<boolean>(false);
const showFilterModal = ref<boolean>(false);
const dividendPayments = ref<PaymentStatus[]>([]);
const selectedDividendPayments = ref<number[]>([]);
const areAllDividendsSelected = ref<boolean>(false);
const dividendDataSelected = ref<PaymentStatus>();
const dividendFilter = ref<DividendsFilter>(new DividendsFilter());

const router = useRouter();
const route = useRoute();
const dividendsId = computed(() => Number(router.currentRoute.value.params.id));

const updatingPaymentsIsPending = ref<boolean>(false);

const columnsUnits = [
  { name: "pendingDate", label: "Fecha" },
  { name: "accountOwnerName", label: "Destinatario" },
  { name: "typeAction", label: "Tipo de Acción" },
  { name: "totalClpStringFormat", label: "Monto" },
  { name: "nominalProfitability", label: "Rentabilidad Nominal" },
  { name: "realProfitability", label: "Rentabilidad Real" },
  { name: "accountNumber", label: "Cuenta destino" },
  { name: "statusStringFormat", label: "Estado" },
];

const dividends = ref<DividendType[]>([]);

async function getAllDividends() {
  let res = await dividendService.getAllDividends();
  if (!res.success) {
    /*alert(
          "Ha ocurrido un error al cargar los dividendos. Vuelve a intentarlo."
        );*/
    dividends.value = [];
    return false;
  }
  dividends.value = res.data;
  dividends.value = dividends.value.sort((dividend1, dividend2) => {
    return (
      new Date(dividend2.distributionDate).getTime() -
      new Date(dividend1.distributionDate).getTime()
    );
  });
}
async function getDividents() {
  const response = await dividendService.getDividendPayments(dividendsId.value);
  if (!response.success) {
    dividendPayments.value = [];
    return;
  }

  dividendPayments.value = response.data?.data;

  dividendPayments.value = dividendPayments.value.sort(
    (dividend1, dividend2) => {
      return (
        new Date(dividend2.pendingDate).getTime() -
        new Date(dividend1.pendingDate).getTime()
      );
    }
  );
  dividendPayments.value = dividendPayments.value.map((dividend) => {
    let newRow = {
      ...dividend,
      accountOwnerName:
        dividend.shareGroup == "GROUP_B"
          ? "ID B: " +
            dividend.investorNumberB +
            " - " +
            dividend.accountOwnerName
          : "ID A: " +
            dividend.investorNumberA +
            " - " +
            dividend.accountOwnerName,

      typeAction: dividend.shareGroup == "GROUP_B" ? `ID B` : `ID A`,
      pendingDate: reformatDate(dividend.pendingDate.toString(), true, false),
      totalClpStringFormat: dividend.totalClp
        ? "$ " + toBadgeFormat(dividend.totalClp)
        : "-",
      statusStringFormat: dividend.status
        ? getPrettyPrintStatus(dividend.status)
        : "-",
    };

    return newRow;
  });
}

async function aplyFilter(dividendFilter: DividendsFilter) {
  await getDividents();
  if (dividendFilter.dateRange != undefined) {
    dividendPayments.value = dividendPayments.value.filter((dividend) => {
      if (dividendFilter.dateRange != undefined) {
        return (
          dividendFilter.dateRange[0] <= new Date(dividend.pendingDate) &&
          new Date(dividend.pendingDate) <= dividendFilter.dateRange[1]
        );
      }
    });
  }
  if (dividendFilter.filterDate != undefined) {
    const filterDateString = dividendFilter.filterDate
      .toISOString()
      .split("T")[0];

    dividendPayments.value = dividendPayments.value.filter((dividend) => {
      const dividendDate = new Date(dividend.pendingDate);
      const dividendDateString = dividendDate.toISOString().split("T")[0];

      if (filterDateString === dividendDateString) {
        return true;
      }
      return false;
    });
  }
  if (dividendFilter.shareholderId != undefined) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.shareholderId == dividendFilter.shareholderId;
    });
  }
  if (!dividendFilter.showPayed) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.status != DividendStatusType.PAID;
    });
  }
  if (!dividendFilter.showPending) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.status != DividendStatusType.PENDING;
    });
  }
  if (!dividendFilter.showRejected) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.status != DividendStatusType.REJECTED;
    });
  }
  if (dividendFilter.dividendId != undefined) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.dividendId == dividendFilter.dividendId;
    });
  }
}
const updateSelectedItems = (selected: any) => {
  //alert("actualizando los seleccionados");

  selectedDividendPayments.value = selected;
  // selectedItems.value = selected;
};
async function modifyMultiplePayments() {
  if (selectedDividendPayments.value.length == 0) return;

  const multiplePaymentData = new MultiplePaymentsData(
    selectedDividendPayments.value,
    dividendNewStatus.value
  );

  updatingPaymentsIsPending.value = true;

  const res = await dividendService.editMultiplePayment(multiplePaymentData);

  updatingPaymentsIsPending.value = false;
  if (!res.data) {
    Swal.fire(
      "¡Error!",
      "Ocurrio un error inesperado, intente nuevamente",
      "error"
    );
  } else {
    Swal.fire(
      "¡Listo!",
      "Se ha cambiado el estado de los pagos seleccionados de forma exitosa",
      "success"
    );
  }
  selectedDividendPayments.value = [];
  areAllDividendsSelected.value = false;
  dividendFilter.value = new DividendsFilter();
  aplyFilter(dividendFilter.value);
  getDividents();
}

async function deleteDividend() {
  dividendFilter.value = new DividendsFilter();
  aplyFilter(dividendFilter.value);
  if (selectedDividendToDelete.value == undefined) return null;
  let res = await dividendService.deleteDividend(
    selectedDividendToDelete.value
  );
  if (res.success) {
    //alert("dividendo eliminado con éxito.");
  }
  getAllDividends();
  getDividents();
  isVisibleConfirmationModal.value = false;
}
function backFilterDividendHandler() {
  dividendFilter.value = new DividendsFilter();
  aplyFilter(dividendFilter.value);

  router.push({ name: "dividends" });

  return false;
}
function filterDividendHandler(Id: number) {
  if (Id == -1) {
    dividendFilter.value = new DividendsFilter();
    aplyFilter(dividendFilter.value);

    return false;
  }
  dividendFilter.value.dividendId = Id;

  aplyFilter(dividendFilter.value);
}

function closeFilterModal() {
  showFilterModal.value = showFilterModal.value ? false : showFilterModal.value;
}
function closeNewDividendModal() {
  showNewDividendModal.value = showNewDividendModal.value
    ? false
    : showNewDividendModal.value;
}
function closeNewDetailModal() {
  //dontRepit yourself
  showDetailModal.value = showDetailModal.value ? false : showDetailModal.value;
}
function getPrettyPrintStatus(status: DividendStatusType) {
  switch (status) {
    case DividendStatusType.PAID:
      return "Pagado";
    case DividendStatusType.PENDING:
      return "Pendiente";
    case DividendStatusType.REJECTED:
      return "Rechazado";
    default:
      break;
  }
  return status;
}
function genericButtonHandler(option: formOptionsType) {
  showNewDividendModal.value = false;
  showFilterModal.value = false;
  switch (option) {
    case formOptionsType.newDividendForm:
      showNewDividendModal.value = true;
      break;

    case formOptionsType.filterForm:
      showFilterModal.value = true;
      break;

    default:
      break;
  }
}

function downloadExcel(dividendId: number) {
  shareholderService.downloadExcel(dividendId);
}

watch(areAllDividendsSelected, () => {
  if (areAllDividendsSelected.value) {
    let selectAllFromDate = dividendPayments.value.map((dividend) => {
      return dividend.id;
    });
    selectedDividendPayments.value = selectAllFromDate;
  } else {
    selectedDividendPayments.value = [];
  }
});

onMounted(async () => {
  //getAllDividends();
  getDividents();

  filterDividendHandler(dividendsId.value);
});

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "",
          onClick: _cache[0] || (_cache[0] = (e) => backFilterDividendHandler())
        }, " Volver "),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Selector, {
            values: [
            _unref(DividendStatusType).PAID,
            _unref(DividendStatusType).PENDING,
            _unref(DividendStatusType).REJECTED,
          ],
            items: [
            getPrettyPrintStatus(_unref(DividendStatusType).PAID),
            getPrettyPrintStatus(_unref(DividendStatusType).PENDING),
            getPrettyPrintStatus(_unref(DividendStatusType).REJECTED),
          ],
            model: dividendNewStatus.value,
            "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((dividendNewStatus).value = $event)),
            class: "w-[200px]"
          }, null, 8, ["values", "items", "model"]),
          _createElementVNode("button", {
            class: "w-[140px] h-[34px] btn",
            onClick: modifyMultiplePayments
          }, _hoisted_7),
          (updatingPaymentsIsPending.value)
            ? (_openBlock(), _createBlock(AppSpinner, {
                key: 0,
                "no-text": ""
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "bg-white text-[#5F5F5F] btn btn-excel w-[124px] h-[33px] flex gap-2 text-sm items-center justify-center",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadExcel(+_unref(route).params.id)))
          }, _hoisted_11),
          _createElementVNode("button", {
            class: "w-[140px] h-[34px] btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (genericButtonHandler(_unref(formOptionsType).filterForm)))
          }, _hoisted_13)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("aside", {
          id: "newDividend",
          class: _normalizeClass(["absolute w-1/5 z-20 rounded-xl top-[200px] border right-[2em] bg-white shadow-lg", showNewDividendModal.value ? 'flex' : 'hidden'])
        }, [
          _createVNode(GenericDividensForm, {
            formOptionSelected: _unref(formOptionsType).newDividendForm,
            onCloseModals: closeNewDividendModal,
            onGetDivident: getDividents,
            onGetAllDividends: getAllDividends
          }, null, 8, ["formOptionSelected"])
        ], 2)), [
          [_directive_click_outside, closeNewDividendModal]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("aside", {
          id: "filter",
          class: _normalizeClass(["absolute w-5/6 lg:w-1/6 z-20 rounded-xl border top-[200px] lg:right-[7em] right-2 bg-white shadow-lg", showFilterModal.value ? 'flex' : 'hidden'])
        }, [
          _createVNode(GenericDividensForm, {
            formOptionSelected: _unref(formOptionsType).filterForm,
            onCloseModals: closeFilterModal,
            onAplyFilter: aplyFilter
          }, null, 8, ["formOptionSelected"])
        ], 2)), [
          [_directive_click_outside, closeFilterModal]
        ])
      ]),
      _createElementVNode("section", _hoisted_14, [
        _createVNode(NewTableComponent, {
          title: '',
          perPage: 10,
          "onUpdate:selected": updateSelectedItems,
          gap: 2,
          "is-selectable": true,
          items: dividendPayments.value,
          columns: columnsUnits,
          buttons: [],
          isSelectPage: false,
          "center-headers": [columnsUnits[7].name],
          "right-headers": [
          columnsUnits[3].name,
          columnsUnits[4].name,
          columnsUnits[5].name,
          columnsUnits[6].name,
        ],
          "bold-headers": [columnsUnits[7].name]
        }, null, 8, ["items", "center-headers", "right-headers", "bold-headers"])
      ])
    ]),
    (_openBlock(), _createBlock(Modal, {
      id: "modal 1",
      key: 1,
      title: "Confirmación",
      visible: isVisibleConfirmationModal.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value))
    }, {
      default: _withCtx(() => [
        _hoisted_15
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "bg-button-green shadow-md text-white",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (deleteDividend()))
        }, " Aceptar ")
      ]),
      _: 1
    }, 8, ["visible"])),
    (showDetailModal.value)
      ? (_openBlock(), _createBlock(DividendDetailModal, {
          key: 0,
          visible: showDetailModal.value,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((showDetailModal).value = $event)),
          dividend: dividendDataSelected.value,
          onClose: closeNewDetailModal,
          onUpdate: getDividents,
          class: "z-10"
        }, null, 8, ["visible", "dividend"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})